<template>
    <div class="fragrance-slider">
        <overlay v-show="showOverlay" @onClickClose="closeOverlay()">
            <h1>{{overlayHeading}}</h1>
            <p v-for="paragraph in overlayBody">{{ paragraph }}</p>
        </overlay>

        <div class="fragrance-header">
            <span :class="['icon',  part.icon]"></span>
            <h3>{{resources.screens.fragrance.heading}}</h3>
        </div>

        <ul class="fragrance-categories">
            <li :class="{'selected': selectedCategory === idx}" v-for="(category, idx) in part.categories">
                <a href="javascript:void(0);" @click="selectCategory(idx)"><span class="category-name">{{category.name}}</span></a>
            </li>
        </ul>

        <div :class="['category-indicator', {'skip-animation': skipIndicatorAnimation}]" :style="'left: ' + indicatorLeft + 'px; width: ' + indicatorWidth + 'px;'"></div>

        <div :class="['category-fragrances', {'gradient-left': !showRightArrow}, {'gradient-right': showRightArrow}]">
            <div class="fragrances-scroll-body">
                <div class="fragrance-options" v-for="(category, catIdx) in part.categories">
                    <h4 class="category-name">{{category.name}}</h4>
                    <ul class="options">
                        <li :class="{'selected': selectedPart === option.id}" v-for="(option, optIdx) in category.options" @click="selectPart(catIdx, optIdx)">
                            <a href="javascript:void(0)">
                                <span class="error-message" v-if="!option.available">
                                    <span class="error-badge"></span>
                                    {{resources.global.notInStockShort}}
                                </span>
                                <span class="icon icon-seal"></span>
                                <span class="option-name">{{option.name}}</span>
                                <span class="option-excerpt">{{option.excerpt}}</span>
                                <span class="option-more" @click="openOverlay(catIdx, optIdx)">{{resources.global.readMore}}</span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <slider-controls
            :showLeftArrow="showLeftArrow"
            :showRightArrow="showRightArrow"
            @clickArrowLeft="onClickArrow('left')"
            @clickArrowRight="onClickArrow('right')">
        </slider-controls>

        <div class="fragrance-footer">
            <button type="button" class="btn btn-customize btn--secondary" v-if="!desktopMode" @click="previousScreen()">
                <span class="icon icon-arrow3--left"></span>
                <span class="sr-only">{{resources.screens.fragrance.buttonChangeProduct}}</span>
            </button>

            <button type="button" class="btn btn-customize" @click="nextScreen()" :disabled="!partAvailable">
                {{resources.screens.fragrance.buttonDone}}
            </button>
        </div>
    </div>
</template>

<script src="./fragrance-slider.js"></script>
